module.exports = __webpack_public_path__ + "img/g2.6b7ae95d.png";